import React from 'react';

import { Patient } from '@/models/PatientModel.ts';
import { Queries } from '@/queries/Queries.ts';
import { CardContent } from '@/uiKit/atoms/card/CardContent.tsx';
import { DiabetesTypeSelectionField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/DiabetesTypeSelectionField.tsx';
import { InsulinSchemeSelectionField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/InsulinSchemeSelectionField.tsx';
import { NoInsulinGestationalWarning } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/NoInsulinGestationalWarning.tsx';
import { TelemonitoringCriteriaSelectionField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/TelemonitoringCriteriaSelectionField.tsx';
import { TelemonitoringDescriptionField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/TelemonitoringDescriptionField.tsx';
import { TelemonitoringDurationField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/TelemonitoringDurationField.tsx';
import { TermDateField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/TermDateField.tsx';

export type CarePlanRenewalFormContentProps = {
  patient: Patient;
};

export const CarePlanRenewalFormContent: React.FC<
  CarePlanRenewalFormContentProps
> = ({ patient }) => {
  const carePlanDirectives = Queries.practitioner.useCarePlanDirectives({
    patientId: patient.id,
  });

  return (
    <CardContent>
      <DiabetesTypeSelectionField
        allowedDiabetesTypes={carePlanDirectives.allowedDiabetesTypes}
      />
      <InsulinSchemeSelectionField
        allowedInsulinSchemes={carePlanDirectives.allowedInsulinScheme}
      />
      <TelemonitoringCriteriaSelectionField
        carePlanDirectives={carePlanDirectives}
        telemonitoringTierRestrictions={carePlanDirectives.restrictions}
      />
      <TelemonitoringDurationField />
      <TelemonitoringDescriptionField patientInfo={patient} />
      <TermDateField />
      <NoInsulinGestationalWarning />
    </CardContent>
  );
};
